<template>
  <div>
    <label>Семейное положение</label>
    <select
      class="form-control mb-2"
      v-model="item"
      @change="$emit('input', item)"
    >
      <option value="0">Выберите</option>
      <option v-for="(i, key) in items" :key="key" :value="i.id">
        {{ i.name }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: null,
    },
    partner: {
      default: function () {
        return {};
      },
    },
  },

  async created() {
    if (this.value) {
      this.item = this.value;
    }
  },
  data() {
    return {
      items: [
        {
          id: "divorced",
          name: "Разведен(а)",
        },
        {
          id: "not_married",
          name: "Не женат/Не замужем",
        },
        {
          id: "married",
          name: "Женат/Замужем",
        },
        {
          id: "widow",
          name: "Вдовец/Вдова",
        },
      ],
      item: null,
      loading: true,
    };
  },
  methods: {},
};
</script>